// styled components 20
import styled from "styled-components"

export const ExampleButton = styled.button`
  background: teal;
  color: gold;
  font-size: 0.95rem;
  width: 115%;
  border-radius: 10px;
  border: 1px solid ghostwhite;
  margin-top: 10px;
`
